import { type ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { HiChevronDoubleDown } from "react-icons/hi2";
import { cn } from "../lib/utils";

export type ModalContentWithScrollStatusMenuProps = {
	children: ReactNode;
	buttons: ReactNode;
	contentClassName?: string;
	scrollMenuClassName?: string;
};

export const ModalContentWithScrollStatusMenu = ({
	children,
	buttons,
	contentClassName,
	scrollMenuClassName,
}: ModalContentWithScrollStatusMenuProps) => {
	const [scrolledBottom, setScrolledBottom] = useState(false);

	const scrollRef = useRef<HTMLDivElement | null>(null);

	const handleScroll = useCallback(() => {
		if (scrollRef.current) {
			const scrollHeight = scrollRef.current.scrollHeight;
			const clientHeight = scrollRef.current.clientHeight;
			const scrollTop = scrollRef.current.scrollTop;

			if (scrollHeight - clientHeight - scrollTop < 32) {
				setScrolledBottom(true);
			} else {
				setScrolledBottom(false);
			}
		}
	}, [scrollRef]);

	useEffect(() => {
		// Used to check if the component is actually larger than the available space, will only update when ref is updated
		if (scrollRef.current) {
			const scrollHeight = scrollRef.current.scrollHeight;
			const clientHeight = scrollRef.current.clientHeight;

			if (scrollHeight - clientHeight < 32) {
				setScrolledBottom(true);
			}
		}
	}, [scrollRef]);

	return (
		<div className="w-full h-full flex flex-col">
			<div
				ref={scrollRef}
				onScroll={handleScroll}
				className={cn("flex-1 overflow-y-auto", contentClassName)}
			>
				{children}
			</div>
			<div
				className={cn(
					"flex items-center w-full px-[24px] py-[10px] border-t border-t-gray-200 bg-gray-50",
					scrollMenuClassName,
				)}
			>
				{!scrolledBottom && (
					<div className="flex items-center gap-x-[8px]">
						<HiChevronDoubleDown className="text-[14px] stroke-[.5]" />
						<span className="text-[14px] font-[450]">Scroll for more</span>
					</div>
				)}
				<div className="flex-1 flex justify-end">{buttons}</div>
			</div>
		</div>
	);
};
